import { createRoute } from '@tanstack/react-router';
import { msg } from 'gt-react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';
import { LabeledRecordPage } from './LabeledRecordPage';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/labeling/labeled',
  staticData: {
    app: {
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.SD849Response },
        ],
      },
    },
  },
  component: LabeledRecordPage,
  loader: () => ({
    crumb: msg('Labeled', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SD849Response,
    });
  },
});
